import { render } from "./EmergencyMedicine.vue?vue&type=template&id=71679388&scoped=true"
import script from "./EmergencyMedicine.vue?vue&type=script&lang=ts"
export * from "./EmergencyMedicine.vue?vue&type=script&lang=ts"

import "./EmergencyMedicine.vue?vue&type=style&index=0&id=71679388&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71679388"

export default script